import React,{useState,useEffect} from 'react'
import image from "../components/eternals.jpg"
import axios from "axios";
function Banner() {
 const [movie, setMovies] = useState({})
useEffect(function () {
    
      axios.get(`https://api.themoviedb.org/3/trending/movie/week?api_key=1bd4fe515239128395e5f867d3913dac&page=1`).then((res) => 
         { console.log(res.data.results)
          setMovies(res.data.results[0])
          
         }
      );
    },[] 
  )
  

  return (
    <div className={`bg-[url(https://image.tmdb.org/t/p/original/${movie.backdrop_path})]
    h-[60vh] md:h-[83vh] bg-center bg-top bg-cover flex items-end justify-center
    `}>
<div className='  text-2xl md:text-5xl text-white bg-stone-700 bg-opacity-50 w-full p-6 flex justify-center'>
{movie.title}</div>
    </div>
  )
}

export default Banner